
const cognitoAuthConfig = {
  authority: "https://cognito-idp.us-west-1.amazonaws.com/us-west-1_xixaBcQJL",
  client_id: "42ekcuqa8m0tj7cb74ntp08sd7",
  redirect_uri: "https://learn.autolexi.com",
  post_logout_redirect_uri: 'https://learn.autolexi.com',
  response_type: "code",
  scope: "openid email",
  automaticSilentRenew: true,
  onSigninCallback: (_user) => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};

export { cognitoAuthConfig }